export default __webpack_public_path__ + "static/media/rug2-min.89fe537b.jpg";